import { ChartData, ChartOptions } from "chart.js";
import { TimeUnit } from "chart.js/types/adapters";
import { TFunction } from "i18next";

import { ChartItem } from "../../../../store/feedbacks/types";

import { FeedbacksChartType } from "./chart";

const datasetsColorMap = [
  { key: "price", color: "#F54759", chartType: "ratings" },
  { key: "speed", color: "#35C768", chartType: "ratings" },
  { key: "convenience", color: "#0C73FE", chartType: "ratings" },
  { key: "ssr", color: "rgb(96, 79, 233)", chartType: "ratings" },
  { key: "csi", color: "rgb(195,75,255)", chartType: "csi" },
];

export const handleOptions = (t: TFunction, chartType: FeedbacksChartType): ChartOptions<"line"> => ({
  spanGaps: false,
  responsive: true,
  plugins: {
    legend: { display: true, position: "bottom" },
    title: { text: t(`charts.${chartType}.title`), display: true },
  },
  elements: { point: { radius: 0 } },
  interaction: { intersect: false, mode: "index" },
  scales: {
    x: {
      type: "time",
      offset: true,
      time: {
        stepSize: 1,
        isoWeekday: 1,
        unit: "day" as TimeUnit,
        minUnit: "day" as TimeUnit,
        tooltipFormat: "YYYY-MM-DD",
        displayFormats: { day: "YYYY-MM-DD", month: "YYYY-MM" },
      },
      ticks: { maxRotation: 0, align: "center" },
    },
    y: {
      max: chartType === "ratings" ? 5 : 100,
      title: { display: true, text: t(`charts.${chartType}.legends.y`) },
    },
  },
});

export const handleData = (
  t: TFunction,
  items: ChartItem[],
  chartType: FeedbacksChartType
): ChartData<"line", ChartItem[]> => ({
  datasets: datasetsColorMap
    .filter((item) => item.chartType === chartType)
    .map(({ key, color }) => ({
      data: items,
      fill: false,
      type: "line",
      borderWidth: 2,
      borderColor: color,
      backgroundColor: color,
      parsing: { yAxisKey: key, xAxisKey: "date" },
      label: t(`charts.${chartType}.datasets.${key}`),
    })),
});
